import { render } from "./BaseLayout.vue?vue&type=template&id=c463f852&scoped=true&ts=true"
import script from "./BaseLayout.vue?vue&type=script&lang=ts"
export * from "./BaseLayout.vue?vue&type=script&lang=ts"

import "./BaseLayout.vue?vue&type=style&index=0&id=c463f852&scoped=true&lang=css"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c463f852"]])

export default __exports__